var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2372_4067)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73438,
    y: 0.945312,
    width: 34,
    height: 34,
    rx: 10,
    fill: "#F6EFE9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2372_4067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9141 11.3643C15.4941 11.3643 11.9141 11.8643 11.9141 15.3643V25.3643C11.9141 26.2143 12.2841 27.0243 12.9141 27.5843V29.3643C12.9141 29.9143 13.3641 30.3643 13.9141 30.3643H14.9141C15.4641 30.3643 15.9141 29.9143 15.9141 29.3643V28.3643H23.9141V29.3643C23.9141 29.9143 24.3641 30.3643 24.9141 30.3643H25.9141C26.4641 30.3643 26.9141 29.9143 26.9141 29.3643V27.5843C27.5441 27.0243 27.9141 26.2143 27.9141 25.3643V15.3643C27.9141 11.8643 24.3341 11.3643 19.9141 11.3643ZM15.4141 26.3643C14.5841 26.3643 13.9141 25.6943 13.9141 24.8643C13.9141 24.0343 14.5841 23.3643 15.4141 23.3643C16.2441 23.3643 16.9141 24.0343 16.9141 24.8643C16.9141 25.6943 16.2441 26.3643 15.4141 26.3643ZM24.4141 26.3643C23.5841 26.3643 22.9141 25.6943 22.9141 24.8643C22.9141 24.0343 23.5841 23.3643 24.4141 23.3643C25.2441 23.3643 25.9141 24.0343 25.9141 24.8643C25.9141 25.6943 25.2441 26.3643 24.4141 26.3643ZM25.9141 20.3643H13.9141V15.3643H25.9141V20.3643ZM31.9141 11.3643V21.3643C31.9141 22.2143 31.5441 23.0243 30.9141 23.5843V25.3643C30.9141 25.9143 30.4641 26.3643 29.9141 26.3643H29.7941C29.8641 26.0443 29.9141 25.7143 29.9141 25.3643V15.3643C29.9141 9.36426 22.9141 9.36426 19.9141 9.36426C19.0041 9.36426 17.7141 9.36426 16.3741 9.53426C17.4641 7.68426 20.4141 7.36426 23.9141 7.36426C28.3341 7.36426 31.9141 7.86426 31.9141 11.3643Z",
    fill: "#8F4300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2372_4067",
    x: 0.734375,
    y: 0.945312,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.970833 0 0 0 0 0.952226 0 0 0 0 0.952226 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2372_4067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2372_4067",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2372_4067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(9.91406 6.36426)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManager);
export default __webpack_public_path__ + "static/media/User_manager.be3a6de941dd1b6f17eebb474ea4131e.svg";
export { ForwardRef as ReactComponent };